import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Image } from '@fiverr-private/media';
import { selectRecipientInfo, selectVacationData, useStaticContext } from '../../../../context/contexts/static';

import VacationCalendar from './vacation.svg';
import style from './style.module.scss';

const formatDateShort = (endsAt) =>
    new Date(endsAt * 1000).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });

export const VacationMessage = () => {
    const context = useStaticContext();
    const { username, displayName } = selectRecipientInfo(context);
    const { endsAt, awayMessage, isContactAllowed } = selectVacationData(context) || {};

    const userDisplayName = displayName || username;

    if (!endsAt) {
        return null;
    }

    return (
        <div className={style.vacationContainer}>
            <Image className={style.vacationImage} src={VacationCalendar} width={88} height={56} alt="vacation"/>
            <div className={style.textContainer}>
                <span className={style.title}>
                    <I18n k={isContactAllowed ? 'send_message.user.unavailable_can_contact': 'send_message.user.unavailable'}
                        params={{ name: userDisplayName, date: formatDateShort(endsAt) }}/>
                </span>
                {awayMessage && (
                    <span className={style.vacationMessage} title={awayMessage}>
                        {`"${awayMessage}"`}
                    </span>
                )}
            </div>
        </div>
    );
};
